export const environment = {
  production: false,
    url:`https://app.debug.testcenter.kz/auth?link=`
};
